/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/view-article-details/shop.view-article-details.component.ts.
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BehaviorSubject, Subscription} from 'rxjs';
import {AppPageloaderService} from '../../../../services/app.pageloader.service';
import {AppViewService} from '../../../../services/app.view.service';
import {Artikel} from '../../../../models/artikel';
import {View} from '../../../../models/view';
import {ArtikelZubehoer} from '../../../../models/artikel-zubehoer';
import {DomainVertreterConfig} from '../../../../models/domain-vertreter-config';
import {AppPageTitleService} from '../../../../services/app.page-title.service';
import {AppConfigService} from '../../../../services/app.config.service';
import {ArtikelWithAktionen} from '../../../../models/artikel-with-aktionen';
import {AppMobileService} from '../../../../services/app.mobile.service';
import * as prettyFileIconsModule from 'pretty-file-icons';
import {OwlOptions} from 'ngx-owl-carousel-o';

/**
 * Zweck: Beschreibt class ShopViewArticleDetailsComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    // tslint:disable-next-line:component-selector
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'shop-view-article-details',
    templateUrl: 'shop.view-article-details.component.html',
    styleUrls: ['shop.view-article-details.component.scss'],
    standalone: false
})
export class ShopViewArticleDetailsComponent implements OnInit, OnDestroy {

  FeatureArtikelinfosBASGFachinformationen = false;
  FeatureArtikelinfosBASGGebrauchsinformationen = false;
  slug: string;
  artid: string;
  view: View;
  rsub: Subscription;
  prettyFileIcons = prettyFileIconsModule;
  zbhloaded = false;
  article = new BehaviorSubject<Artikel>(null);
  zubehoer = new BehaviorSubject<ArtikelZubehoer[]>([]);
  aktionen: BehaviorSubject<ArtikelWithAktionen> = new BehaviorSubject<ArtikelWithAktionen>(null);
  field = [
    'logo1',
    'logo2',
    'bezeichnung',
    'minablauf',
    'darreichungsform',
    'hersteller',
    'pzn',
    'verkaufspreis',
    'kassapreis',
    'einkaufspreis',
    'rezeptzeichen',
    'istarzneimittel',
    'Kurzbeschreibung',
    'Laenge',
    'Breite',
    'Hoehe',
    'Gewicht',
    'Muendung',
    'Beschreibung',
    'Produktfamilie',
    'Zulassungsnummer',
    'status',
  ];
  zubhfield = [
    // 'darreichungsform',
    'hersteller',
    // 'pzn',
    // 'verkaufspreis',
    'einkaufspreis',
    // 'rezeptzeichen',
    // 'istarzneimittel',
    'status',
  ];
  checkempty_fields = [
    'Laenge',
    'Breite',
    'Gewicht',
    'Muendung',
    'Produktfamilie',
    'Beschreibung',
  ];
  vertreterconfig: BehaviorSubject<DomainVertreterConfig> = new BehaviorSubject<DomainVertreterConfig>(null);
  @ViewChild('zbscrollboxinner') zbscrollboxinner: ElementRef;


  renderFields = [];
  renderFields1 = [];
  renderFields2 = [];

  carouselOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true
  };

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private route: ActivatedRoute, private loader: AppPageloaderService, private svc: AppViewService,
              private tsvc: AppPageTitleService, public cfg: AppConfigService, public msvc: AppMobileService,
              private cd: ChangeDetectorRef) {
  }

  private detectChanges() {
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }

/**
 * Beschreibt Methode isFieldEmpty und ihren Rückgabevertrag.
 */
  isFieldEmpty(article: Artikel, fname) {
    if (this.checkempty_fields.includes(fname)) {
      const value = article[fname];

      return (value === '' || value === undefined || value === null);
    } else {
      return false;
    }
  }

/**
 * Beschreibt Methode zbscrollleft und ihren Rückgabevertrag.
 */
  zbscrollleft($event) {
    $event.stopImmediatePropagation();
    $event.preventDefault();
    this.zbscrollboxinner.nativeElement.scrollLeft -= 300;
  }

/**
 * Beschreibt Methode zbscrollright und ihren Rückgabevertrag.
 */
  zbscrollright($event) {
    $event.stopImmediatePropagation();
    $event.preventDefault();
    this.zbscrollboxinner.nativeElement.scrollLeft += 300;
  }

/**
 * Beschreibt Methode init und ihren Rückgabevertrag.
 */
  init() {
    this.renderFields = [];
    this.field.forEach(fieldname => {
      let add = true;
      if (!this.cfg.featuresEnabledAll(['ArtikelinfosBestand', 'ArtikelinfosMinAblauf']) && fieldname == 'minablauf') {
        add = false;
      }
      if (this.view.settings.hidden_fields && this.view.settings.hidden_fields.includes(fieldname)) {
        add = false;
      }
      if (add) {
        if (fieldname != 'ArtikelName' && !this.isFieldEmpty(this.article.value, fieldname)) {
          this.renderFields.push(fieldname);
        }
      }
    });

    const half = Math.ceil(this.renderFields.length / 2);

    this.renderFields1 = this.renderFields.slice(0, half);
    this.renderFields2 = this.renderFields.slice(half, this.renderFields.length);
    this.detectChanges();
  }


/**
 * Beschreibt Methode loadAktionen und ihren Rückgabevertrag.
 */
  loadAktionen() {
    if (this.article.value && this.view) {
      this.svc.getAktionenSlug(this.view.slug, this.article.value).subscribe(a => {
        const artwakt = new ArtikelWithAktionen();
        artwakt.artikel = this.article.value;
        artwakt.aktionen = a;
        this.aktionen.next(artwakt);
      });
    }
  }

/**
 * Beschreibt Methode load und ihren Rückgabevertrag.
 */
  load() {
    if (this.slug && this.artid) {
      this.article.next(null);
      this.zubehoer.next([]);
      this.svc.getBySlug(this.slug).subscribe(v => {
        this.view = v;
        this.tryInit();
      });

      const l = this.loader.start();
      this.svc.getOneById(this.slug, this.artid).subscribe({
        next: (art) => {
          l.stop();
          this.tsvc.setTitle2(art.ArtikelName);
          this.article.next(art);
          this.tryInit();
          this.zubehoer.next(art.zubehoer);
        },
        error: () => {
          l.stop();
        }
      });
    }
  }

/**
 * Beschreibt Methode tryInit und ihren Rückgabevertrag.
 */
  tryInit() {
    if (this.view && this.view.settings && this.article.value) {
      this.init();
      this.loadAktionen();
    }
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this.tsvc.resetTitle2();
    if (this.rsub instanceof Subscription) {
      this.rsub.unsubscribe();
    }
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.FeatureArtikelinfosBASGFachinformationen = this.cfg.featuresEnabled(['ArtikelinfosBASGFachinformationen']);
    this.FeatureArtikelinfosBASGGebrauchsinformationen = this.cfg.featuresEnabled(['ArtikelinfosBASGGebrauchsinformationen']);

    this.route.parent.params.subscribe(p => {
      this.slug = p['slug'];

      this.load();
    });
    this.rsub = this.route.params.subscribe(p => {
      this.artid = p['artid'];

      if (p['slug']) {
        this.slug = p['slug'];
      }

      this.load();
    });
  }


}
